import {
  deleteSection,
  restoreSection,
} from "../../../actions/DocumentActions";
import { getContentForComponent } from "../../../utils/documentUtils";
import BaseCommand from "../../baseCommand";
import { DOCUMENTS } from "../../../constants";

const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
class DocTemplateBaseCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  prepareLayout() {
    const { layout, newRow, rowIndex, colIndex, component } =
      this.componentData;
    this.newLayout = [...layout];
    if (newRow) {
      this.newLayout.splice(rowIndex, 0, [component.id]);
    } else if (!newRow) {
      const rowIDs = [...this.newLayout[rowIndex]];
      rowIDs.splice(colIndex, 0, component.id);
      this.newLayout[rowIndex] = rowIDs;
    }
  }

  getActiveEditorPayload() {
    return {
      section: this.activeComponent,
      editorState: this.activeEditorState,
    };
  }

  updateRedux(activeEditorPayload) {
    const {
      component,
      dbRowIndex,
      headerFooterType,
      dbColIndex,
      shouldNotActivateComponent,
    } = this.componentData;

    // Updating the redux before the add component service to
    // avoid the slow user exeperience
    this.componentData.addDocumentComponentAction(
      this.newLayout,
      component,
      dbRowIndex,
      dbColIndex,
      headerFooterType,
      shouldNotActivateComponent,
      activeEditorPayload,
    );
  }

  getComponentPayload() {
    const { component, mode, dbRowIndex, dbColIndex, newRow } =
      this.componentData;
    return {
      component: {
        content: getContentForComponent(component, mode),
        row: dbRowIndex,
        col: dbColIndex,
        component_id: component.id,
      },
      new_row_added: newRow,
    };
  }

  redo() {
    const {
      component,
      dbRowIndex,
      dbColIndex,
      headerFooterType,
      activeEditorPayload,
      mode,
      docNo,
      docID,
    } = this.componentData;
    if (component) {
      this.scrollIntoView(component.id);
    }
    restoreSection(mode)(docNo || docID, component, this.newLayout);
    this.componentData.addDocumentComponentAction(
      this.newLayout,
      component,
      dbRowIndex,
      dbColIndex,
      headerFooterType,
      true,
      activeEditorPayload,
    );
  }

  execute() {
    if (this.isRedo) {
      this.redo();
    } else {
      // 1.
      this.prepareLayout();
      // 2.
      const activeEditorPayload = this.getActiveEditorPayload();
      // 3.
      this.updateRedux(activeEditorPayload);
      const { component, updatePageBreakScrollViewAction } = this.componentData;
      if (
        component.type === DOCUMENT_COMPONENT_TYPES.PAGE_BREAK &&
        updatePageBreakScrollViewAction
      ) {
        updatePageBreakScrollViewAction(component.id);
      }
    }
  }

  undo() {
    const { component, mode, docID, docNo } = this.componentData;

    // Scroll section into view when do Undo
    if (component) {
      this.scrollIntoView(component.id);
    }
    deleteSection(mode)(docNo || docID, component);

    this.componentData.removeComponentInDocument(
      component.id,
      this.nukeAddComponentType,
    );
    if (this.nukeAddComponentType) {
      this.nukeAddComponentType = false;
    }
    this.isRedo = true;
  }
}

export default DocTemplateBaseCommand;
